import {
  ShieldCheck,
  AlertTriangle,
  Building2,
  ClipboardCheck,
  FileSearch,
  Umbrella,
} from "lucide-react";
import { SERVICES } from "@/lib/constants";
import { useInView } from "@/hooks/useInView";

const ICON_MAP = {
  ShieldCheck,
  AlertTriangle,
  Building2,
  ClipboardCheck,
  FileSearch,
  Umbrella,
};

const ServiceCard = ({ s, idx }) => {
  const { ref, inView } = useInView();
  const Icon = ICON_MAP[s.icon] || ShieldCheck;
  return (
    <div
      ref={ref}
      data-testid={`service-card-${idx}`}
      className={`ra-card p-8 md:p-10 fade-up ${inView ? "in-view" : ""}`}
      style={{ transitionDelay: `${idx * 80}ms` }}
    >
      <div className="ra-icon-plate mb-7">
        <Icon size={24} strokeWidth={1.6} />
      </div>
      <h3 className="font-heading text-[#111827] text-xl md:text-[22px] font-semibold leading-snug mb-4">
        {s.title}
      </h3>
      <p className="font-body text-[#4B5563] text-[15px] leading-relaxed">
        {s.description}
      </p>
      <div className="mt-7 inline-flex items-center gap-2 text-[#00A859] text-[11px] tracking-[0.28em] uppercase font-heading font-semibold">
        <span>0{idx + 1}</span>
        <span className="w-6 h-px bg-[#00A859]" />
        <span className="text-[#111827]/60">Advisory Service</span>
      </div>
    </div>
  );
};

export const Services = () => {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="bg-[#F8F9FA] py-24 md:py-32"
    >
      <div className="max-w-[1320px] mx-auto px-6 md:px-10 lg:px-14">
        <div className="grid lg:grid-cols-12 gap-10 mb-16 md:mb-20 items-end">
          <div className="lg:col-span-7">
            <div className="ra-eyebrow mb-6">
              <span className="ra-hairline" />
              <span>What We Do</span>
            </div>
            <h2 className="font-heading text-[#0A1128] text-3xl md:text-4xl lg:text-[52px] font-medium leading-[1.08] tracking-tight">
              Independent Advisory Services
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="font-body text-[#4B5563] text-base md:text-[17px] leading-relaxed">
              Specialized counsel across the full project lifecycle — from
              acquisition and feasibility through execution and close-out.
              Built to protect capital, reduce exposure, and elevate outcomes.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {SERVICES.map((s, i) => (
            <ServiceCard key={s.title} s={s} idx={i} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
